import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export function disableQuestionService(questionId, chapterId) {
  const payload = { chapterId };
  return axios
    .post(`${BASE_URL}/disableQuestion/${questionId}`, payload)
    .then(({ data }) => data);
}

export function reportQuestionService(questionId, payload) {
  return axios
    .post(`${BASE_URL}/question/${questionId}/report`, payload)
    .then(({ data }) => data);
}
